import OutLineMobileFive from '@assets/icons/outline-mobile-five.svg'
import { Icon } from './Icon'

export const OutLineMobileFiveIcon = Icon(OutLineMobileFive)
